<template>
  <div class="share-list">
    <div
      class="s-item"
      v-if="cusChannel.indexOf(1) > -1"
      @click.stop="showShare(2)"
      v-track="[{ act: 'click', params: { content_name: '微信好友', ...customParams } }]"
    >
      <div class="icon wx"><img src="../img/icon_rec.png" alt="" class="icon-rec" /></div>
      <span class="s-des">微信好友</span>
    </div>
    <div
      class="s-item"
      v-if="cusChannel.indexOf(1) > -1"
      @click.stop="showShare(3)"
      v-track="[{ act: 'click', params: { content_name: '朋友圈', ...customParams } }]"
    >
      <div class="icon pyq"></div>
      <span class="s-des">朋友圈</span>
    </div>
    <div
      class="s-item"
      v-if="cusChannel.indexOf(3) > -1 && !isIOSVivoApp"
      @click.stop="showShare(8)"
      v-track="[{ act: 'click', params: { content_name: '分享海报', ...customParams } }]"
    >
      <div class="icon hb"></div>
      <span class="s-des">分享海报</span>
    </div>
  </div>
</template>

<script>
import app from 'utils/app'
import env from 'utils/clientEnv'
import fetch from 'api/fetch'

export default {
  name: 'share-item',
  props: {
    cusChannel: {
      type: Array,
      default: () => [1, 2, 3]
    },
    shareParams: Object,
    customParams: Object,
    posterParams: Object
  },

  data() {
    return {
      isShowList: false, // 赠品弹层列表是否展示
      isIOSVivoApp: env.isIOSVivoApp
    }
  },
  computed: {},
  mounted() {
    // let params = {
    //   'shareChannel': '8',
    //   'posterUrl': 'https://shopstatic.vivo.com.cn/vivoshop/poster/20190606/2019060615213985689_original.jpg',
    //   'posterShareTitle': '分享海报给好友'
    // }
    // window.WeiwoJSBridge.call('showShare', params)
  },
  methods: {
    async showShare(channel) {
      let sParams = Object.assign({}, this.shareParams)
      sParams.shareChannel = channel
      if (channel == 8) {
        sParams = {
          shareChannel: 8,
          posterShareTitle: '分享海报给好友'
        }
        // 优先获取参数中的，没有调用api获取
        if (this.shareParams.posterUrl) {
          sParams.posterUrl = this.shareParams.posterUrl
        } else {
          const data = await fetch(this.posterParams)
          if (data) {
            sParams.posterUrl = data
          } else {
            this.$toast('获取分享海报失败，请稍后重试')
            return
          }
        }
      }
      // 唤起分享前关闭当前分享弹层
      this.$emit('close')
      app.showShare(sParams)
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
